import { defineStore } from 'pinia'

export const useLoadingStore = defineStore('loading', {
    state: () => ({
        loading: false
    }),
    getters: {
        isLoading: (state) => state.loading
    },
    actions: {
        startLoading() {
            this.loading = true
        },
        stopLoading() {
            this.loading = false
        },
        setLoading(value) {
            this.loading = value
        }
    }
})
